(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vc-review-submissions"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.vc-review details').forEach(function(details) {
  if (details.querySelector('[role="status"], [role="alert"]')) details.open = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vc-soundtrack"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', function(event) {
  if (!event.target.matches('.vc-soundtrack-select')) return;
  const select = event.target;
  const frame = select.closest('.vc-soundtrack').querySelector('iframe');
  const option = select.selectedOptions[0];
  frame.src = select.value;
  frame.height = option.dataset.height;
  frame.title = option.textContent + ' on Spotify';
});

  } catch(e) { console.error(e); }
})();
})();
